/**
 * Function to sum properties of values in an array by the iteratee provided.
 *
 * @example
 * // Returns 3
 * sumBy([ {a: 1}, {a: 2}], 'a')
 * // Returns 3
 * sumBy([ {a: 1}, {a: 2}], (object) => object.a)
 *
 * @param {Array} array Array of objects to be summed
 * @param {string} iteratee Property name or iteratee
 * @returns The sum of the numbers returned by iteratee on array
 */
function sumBy(array, iteratee) {
	let realIteratee = iteratee;
	if (typeof iteratee === 'string') {
		realIteratee = object => object[iteratee];
	}
	return array.reduce((sum, object) => sum + realIteratee(object), 0);
}

export default sumBy;
